import React from 'react';
import { Link } from 'react-router-dom';
import { ListItem, ListItemText } from '@mui/material';
import { get } from 'global/lib/lodash';
import { Loading, useScreen } from 'global/styles';
import moment from 'moment';
import TypoLabel from 'global/components/typo-label';
import useStyles from './TaskListSC.styles';
import { useDispatch, useSelector } from 'react-redux';
import { removeNewTask, addNewTask } from 'redux/actions/view';
import { stopProp } from '../../../global/utils';
import { Row } from '../../../global/components/row';

export default function TaskListItem(props) {
  const { item, isTitle, tableRows } = props;
  const classes = useStyles();
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const dispatch = useDispatch();
  const isSelected = newTasks.find((t) => t.id === item.id);

  const { isMobile } = useScreen();

  const content = {
    ...item,
    isSelected,
    realmType: get(item, 'type', Loading),
    label: get(item, 'name', Loading),
    realmName: get(item, 'label', Loading),
    updatedDate: get(item, 'date', Loading),
    agingDate: get(item, 'createdAt', Loading),
    checkTitles: get(item, 'checkTitle', 'Some content'),
    author: get(item, 'authors', [])
      .map((a) => get(a, 'name'))
      .join(', '),
    assignee: get(item, 'assignees', [])
      .map((a) => get(a, 'name'))
      .join(', '),
    standard: get(item, 'checkpoint.id') ? `${get(item, 'checkpoint.id', '')}: ${get(item, 'checkpoint.name', '')}` : Loading,
    tradeTypes: get(item, 'tradeTypes'),
    onCheckClick: () => {
      if (isSelected) {
        dispatch(removeNewTask(item));
      } else {
        dispatch(addNewTask({ ...item, fromSelected: true }));
      }
    },
    onSelect: s => {
      stopProp(s);
    },
    onClick: e => {
      props.onClick && props.onClick(e, item)
    }
  };

  const dayDiff = Math.abs(moment.utc(content.agingDate).startOf('day').diff(moment.utc().startOf('day'), 'days'));
  content.agingDate = `${dayDiff} days`;
  const [ico, ...trows] = tableRows;

  return (
    <ListItem 
      button 
      divider={true} 
      key={item.id} 
      disableGutters={true} 
      style={{ padding: 0, pageBreakInside: 'avoid' }}
      onClick={content.onClick}
    >
      <ListItemText
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          isMobile ? (
            <Row style={{ flexWrap: 'wrap' }}>
              {ico.val(content)}
              <div>
                {trows.map((tr, i) => {
                  return <TypoLabel key={i} primary={`${tr.title}: `} secondary={tr.val(content)} />                    
                })}
              </div>
            </Row>
          ) : (
            <div className={classes.tableRow}>
              {tableRows.map((tr, i) => (
                <div key={i} style={{ width: tr.width, ...(tr.style || {}) }}>
                  {tr.val(content)}
                </div>
              ))}
            </div>
          )
        }
      />
    </ListItem>
  );
}
